import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dog_name = () => {
  return [
    {
      type: 'input',
      name: 'name',
      disabledIfValueExists: true,
      label: {
        type: 'translatableText',
        translationKey: 'sharedFlows_dogLiabilityNxt:steps.dog_list.name',
      },
    },
  ] as const satisfies AnyStepConfiguration['stepContent']
}

export default dog_name
